<template>
  <div>
    <div class="bj dis-cent">
      <div class="content">
        <div class="headBox">
          <div class="title">请选择职位类别</div>
          <div class="inpBox">
            <div class="iconfont icon-search search dis-cent"></div>
            <div class="box">
              <input
                type="text"
                placeholder="请输入名称搜索"
                v-model="searchTxt"
                @keyup.enter="searchClick"
              />
            </div>
          </div>
          <div class="youBox">
            <div class="iconfont icon-close close" @click="dleClick"></div>
          </div>
        </div>
        <div class="cont">
          <div class="contLeft scroll">
            <div
              class="text"
              :class="index == typeOn ? 'on' : ''"
              :key="item.id"
              v-for="(item, index) in category_jobs"
              @click="typeClick(index)"
            >
              <div class="name" :class="index == typeOn ? 'nameOn' : ''">
                {{ item.categoryname }}
              </div>
              <div class="num">
                <span class="dis-cent" v-if="item.num">{{ item.num }}</span>
              </div>
              <div
                class="kuang"
                :class="item.select ? 'kOn' : ''"
                @click="waiClick(index)"
              >
                <div class="iconfont icon-right" v-if="item.select"></div>
              </div>
              <div
                class="txt"
                :class="item.select ? 'kTxtOn' : ''"
                @click="waiClick(index)"
              >
                全选
              </div>
            </div>
          </div>
          <div class="contRig">
            <div class="nrCont">
              <div v-for="(item, index) in category_jobs_chi" :key="item.id">
                <div class="nameBox">
                  <div class="name">
                    {{ item.categoryname }}
                  </div>
                  <div
                    class="kuang"
                    :class="item.select ? 'kOn' : ''"
                    @click="lingClick(index)"
                  >
                    <div class="iconfont icon-right" v-if="item.select"></div>
                  </div>
                  <div
                    class="ktxt"
                    :class="item.select ? 'kTxtOn' : ''"
                    @click="lingClick(index)"
                  >
                    全选
                  </div>
                </div>
                <div class="nrContBox">
                  <div
                    class="text dis-cent"
                    :class="chi.select ? 'on' : ''"
                    :key="chi.id"
                    v-for="(chi, chiIndex) in item.children"
                    @click="contClick(index, chiIndex)"
                  >
                    {{ chi.categoryname }}
                  </div>
                </div>
              </div>
            </div>
            <div class="diCont">
              <div class="name">已选:</div>
              <div class="box">
                <div
                  class="textBox dis-cent"
                  v-for="(item, index) in xzList"
                  :key="item.id"
                >
                  <div class="txt">{{ item.categoryname }}</div>
                  <div
                    class="iconfont icon-close close"
                    @click="delClick(item, index)"
                  ></div>
                </div>
              </div>
              <div class="btn dis-cent" @click="gbClick">确认</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { watch } from "less";

export default {
  name: "",
  data() {
    return {
      typeOn: 0,
      list: [
        {
          name: "互联网",
          num: 0,
          chi: [
            {
              name: "前端开发1",
              select: false,
            },
            {
              select: false,
              name: "前端开发2",
            },
            {
              select: false,
              name: "前端开发3",
            },
            {
              select: false,
              name: "前端开发4",
            },
          ],
        },
        {
          name: "互联网",
          num: 0,
          chi: [
            {
              select: false,
              name: "前端开发5",
            },
            {
              select: false,
              name: "前端开发6",
            },
            {
              select: false,
              name: "前端开发7",
            },
            {
              select: false,
              name: "前端开发8",
            },
          ],
        },
        {
          name: "互联网",
          num: 0,
          chi: [
            {
              select: false,
              name: "前端开发9",
            },
            {
              select: false,
              name: "前端开发10",
            },
            {
              select: false,
              name: "前端开发11",
            },
            {
              select: false,
              name: "前端开发12",
            },
          ],
        },
      ],
      contOn: null,
      contList: [],
      xzList: [],
      category_jobs_on: 0,
      category_jobs: [],
      category_jobs_chi: [],
      searchTxt: "",
      yuanCategory_jobs: [],
      qwFuData: [],
    };
  },
  props: ["qwData", "num"],
  watch: {
    qwData() {
      this.mrfzGet();
    },
  },
  created() {
    this.getType();
  },
  methods: {
    searchClick() {
      console.log(this.searchTxt);
      this.typeOn = 0;
      if (this.searchTxt) {
        console.log(
          this.filterRecursive(this.yuanCategory_jobs, this.searchTxt)
        );
        this.category_jobs = this.filterRecursive(
          this.yuanCategory_jobs,
          this.searchTxt
        );
        this.category_jobs_chi = this.category_jobs[0].children;
      } else {
        this.category_jobs = this.yuanCategory_jobs;
        this.category_jobs_chi = this.yuanCategory_jobs[0].children;
      }
      // this.qwData = JSON.parse(JSON.stringify(this.xzList));
      this.fzmrfzGet();
    },
    filterRecursive(data, query) {
      data = JSON.stringify(data);
      data = JSON.parse(data);
      return data.filter((item) => {
        const isMatch = item.categoryname.toLowerCase().includes(query);
        if (item.children) {
          const filteredChildren = this.filterRecursive(item.children, query);
          if (filteredChildren.length > 0) {
            item.children = filteredChildren;
            return true;
          }
        }
        return isMatch;
      });
    },
    getType() {
      let version = window.localStorage.getItem("version");
      console.log(version + '-111');
      this.$get("/common/category_jobs_gets", {
        version: version ? version : 1,
      }).then((res) => {
        console.log(res);
        
        if (res.data.length != 0) {
          window.localStorage.setItem("version", res.version);
          window.localStorage.setItem(
            "category_jobs",
            JSON.stringify(res.data)
          );
          this.category_jobs = res.data;
          this.yuanCategory_jobs = res.data;
          for (let i = 0; i < this.category_jobs.length; i++) {
            const e = this.category_jobs[i];
            e.num = 0;
          }
          if (this.qwData[0]) {
            this.mrfzGet();
          } else {
            this.category_jobs_chi = res.data[0].children;
          }
        } else {
          let category_jobs = JSON.parse(
            window.localStorage.getItem("category_jobs")
          );
          this.category_jobs = category_jobs;
          this.yuanCategory_jobs = category_jobs;
          for (let i = 0; i < this.category_jobs.length; i++) {
            const e = this.category_jobs[i];
            e.num = 0;
          }
          if (this.qwData[0]) {
            if (this.qwData[0].categoryname) {
              this.mrfzGet();
            } else {
              this.category_jobs_chi = category_jobs[0].children;
            }
          } else {
            this.category_jobs_chi = category_jobs[0].children;
          }
        }
      });
    },
    dleClick() {
      this.$emit("show");
    },
    gbClick() {
      this.$emit("show", { data: this.xzList });
    },
    typeClick(i) {
      this.typeOn = i;
      this.category_jobs_chi = this.category_jobs[i].children;
    },
    waiClick(i) {
      if (this.num != 1) {
        if (this.xzList.length >= this.num) {
          if (!this.category_jobs[i].select) {
            this.$message.warning("最多只能选择" + this.num + "个");
            return;
          }
        }
      } else {
        this.xzList = [];
        for (let j = 0; j < this.category_jobs.length; j++) {
          const e = this.category_jobs[j];
          e.select = false;
          e.num = 0;
          for (let j = 0; j < e.children.length; j++) {
            const ej = e.children[j];
            ej.select = false;
            for (let x = 0; x < ej.children.length; x++) {
              const ex = ej.children[x];
              ex.select = false;
            }
          }
        }
      }
      this.category_jobs[i].select = !this.category_jobs[i].select;
      if (this.category_jobs[i].select) {
        for (let j = 0; j < this.category_jobs[i].children.length; j++) {
          const ej = this.category_jobs[i].children[j];
          if (ej.select) {
            for (let a = 0; a < this.xzList.length; a++) {
              const ea = this.xzList[a];
              if (ea.id == ej.id) {
                this.category_jobs[i].num--;
                this.xzList.splice(a, 1);
              }
            }
            ej.select = false;
          }
          for (let x = 0; x < ej.children.length; x++) {
            const ex = ej.children[x];
            if (ex.select) {
              for (let a = 0; a < this.xzList.length; a++) {
                const ea = this.xzList[a];
                console.log(ea);
                if (ea.id == ex.id) {
                  this.category_jobs[i].num--;
                  this.xzList.splice(a, 1);
                }
                ex.select = false;
              }
            }
          }
        }
      }
      // this.fzGet();
      if (this.category_jobs[i].select) {
        this.category_jobs[i].num++;
        this.xzList.push({
          ...this.category_jobs[i],
          zTxt: this.category_jobs[i].categoryname,
          key: this.category_jobs[i].id + "",
        });
      } else {
        if (this.num == 1) {
          this.category_jobs[i].num++;
          this.xzList.push({
            ...this.category_jobs[i],
            zTxt: this.category_jobs[i].categoryname,
            key: this.category_jobs[i].id + "",
          });
        } else {
          this.category_jobs[i].num--;
          for (let x = 0; x < this.xzList.length; x++) {
            const e = this.xzList[x];
            if (e.id == this.category_jobs[i].id) {
              this.xzList.splice(x, 1);
            }
          }
        }
      }
    },
    lingClick(i) {
      let typeOn = this.typeOn;
      if (this.num != 1) {
        if (this.category_jobs[typeOn].select) {
          this.$message.warning("勾选上级后会包含所有子内容，请不要重复勾选");
          return;
        }
        if (this.xzList.length >= this.num) {
          if (!this.category_jobs_chi[i].select) {
            this.$message.warning("最多只能选择" + this.num + "个");
            return;
          }
        }
      } else {
        this.xzList = [];
        for (let j = 0; j < this.category_jobs.length; j++) {
          const e = this.category_jobs[j];
          e.select = false;
          e.num = 0;
          for (let j = 0; j < e.children.length; j++) {
            const ej = e.children[j];
            ej.select = false;
            for (let x = 0; x < ej.children.length; x++) {
              const ex = ej.children[x];
              ex.select = false;
            }
          }
        }
      }
      this.category_jobs_chi[i].select = !this.category_jobs_chi[i].select;
      if (this.category_jobs_chi[i].select) {
        let children = this.category_jobs_chi[i].children;
        for (let i = 0; i < children.length; i++) {
          const e = children[i];
          if (e.select) {
            for (let x = 0; x < this.xzList.length; x++) {
              const ex = this.xzList[x];
              if (ex.id == e.id) {
                this.category_jobs[this.typeOn].num--;
                this.xzList.splice(x, 1);
              }
            }
            e.select = false;
          }
        }
      }
      // this.fzGet();
      if (this.category_jobs_chi[i].select) {
        this.category_jobs[this.typeOn].num++;
        this.xzList.push({
          ...this.category_jobs_chi[i],
          zTxt: this.category_jobs_chi[i].categoryname,
          key:
            this.category_jobs[this.typeOn].id +
            "," +
            this.category_jobs_chi[i].id,
        });
      } else {
        if (this.num == 1) {
          this.category_jobs[this.typeOn].num++;
          this.xzList.push({
            ...this.category_jobs_chi[i],
            zTxt: this.category_jobs_chi[i].categoryname,
            key:
              this.category_jobs[this.typeOn].id +
              "," +
              this.category_jobs_chi[i].id,
          });
        } else {
          this.category_jobs[this.typeOn].num--;
          for (let x = 0; x < this.xzList.length; x++) {
            const e = this.xzList[x];
            if (e.id == this.category_jobs_chi[i].id) {
              this.xzList.splice(x, 1);
            }
          }
        }
      }
    },
    contClick(i, chiI) {
      if (this.num != 1) {
        if (this.category_jobs_chi[i].select) {
          this.$message.warning("勾选上级后会包含所有子内容，请不要重复勾选");
          return;
        }
        let typeOn = this.typeOn;
        if (this.category_jobs[typeOn].select) {
          this.$message.warning("勾选上级后会包含所有子内容，请不要重复勾选");
          return;
        }
        if (this.xzList.length >= this.num) {
          if (!this.category_jobs_chi[i].children[chiI].select) {
            this.$message.warning("最多只能选择" + this.num + "个");
            return;
          }
        }
      } else {
        this.xzList = [];
        for (let j = 0; j < this.category_jobs.length; j++) {
          const e = this.category_jobs[j];
          e.select = false;
          e.num = 0;
          for (let j = 0; j < e.children.length; j++) {
            const ej = e.children[j];
            ej.select = false;
            for (let x = 0; x < ej.children.length; x++) {
              const ex = ej.children[x];
              ex.select = false;
            }
          }
        }
      }
      this.category_jobs_chi[i].children[chiI].select =
        !this.category_jobs_chi[i].children[chiI].select;
      // this.fzGet();
      if (this.category_jobs_chi[i].children[chiI].select) {
        this.category_jobs[this.typeOn].num++;
        this.xzList.push({
          ...this.category_jobs_chi[i].children[chiI],
          zTxt: this.category_jobs_chi[i].children[chiI].categoryname,
          key:
            this.category_jobs[this.typeOn].id +
            "," +
            this.category_jobs_chi[i].id +
            "," +
            this.category_jobs_chi[i].children[chiI].id,
        });
      } else {
        if (this.num == 1) {
          this.category_jobs[this.typeOn].num++;
          this.xzList.push({
            ...this.category_jobs_chi[i].children[chiI],
            zTxt: this.category_jobs_chi[i].children[chiI].categoryname,
            key:
              this.category_jobs[this.typeOn].id +
              "," +
              this.category_jobs_chi[i].id +
              "," +
              this.category_jobs_chi[i].children[chiI].id,
          });
        } else {
          this.category_jobs[this.typeOn].num--;
          for (let x = 0; x < this.xzList.length; x++) {
            const e = this.xzList[x];
            if (e.id == this.category_jobs_chi[i].children[chiI].id) {
              this.xzList.splice(x, 1);
            }
          }
        }
      }
      console.log(this.xzList);
    },
    fzGet() {
      let xzList = [];
      for (let i = 0; i < this.category_jobs.length; i++) {
        const e = this.category_jobs[i];
        e.num = 0;
        if (e.select) {
          e.num++;
          xzList.push({
            ...e,
            key: e.id + "",
            zTxt: e.categoryname,
          });
        }
        for (let j = 0; j < e.children.length; j++) {
          const ej = e.children[j];
          if (ej.select) {
            e.num++;
            xzList.push({
              ...ej,
              key: e.id + "," + ej.id,
              zTxt: ej.categoryname,
            });
          }
          for (let x = 0; x < ej.children.length; x++) {
            const ex = ej.children[x];
            if (ex.select) {
              e.num++;
              xzList.push({
                ...ex,
                key: e.id + "," + ej.id + "," + ex.id,
                zTxt: ex.categoryname,
              });
            }
          }
        }
      }
      this.xzList = xzList;
    },
    // 默认赋值
    mrfzGet() {
      let xzList = [];
      for (let i = 0; i < this.category_jobs.length; i++) {
        const e = this.category_jobs[i];
        e.num = 0;
        for (let y = 0; y < this.qwData.length; y++) {
          const ey = this.qwData[y];
          if (e.categoryname == ey.categoryname) {
            this.typeOn = i;
            this.category_jobs_chi = e.children;
            e.select = true;
            e.num++;
            xzList.push(ey);
          }
        }
        for (let j = 0; j < e.children.length; j++) {
          const ej = e.children[j];
          for (let y = 0; y < this.qwData.length; y++) {
            const ey = this.qwData[y];
            if (ej.categoryname == ey.categoryname) {
              this.typeOn = i;
              this.category_jobs_chi = e.children;
              ej.select = true;
              e.num++;
              xzList.push(ey);
            }
          }
          for (let x = 0; x < ej.children.length; x++) {
            const ex = ej.children[x];
            for (let y = 0; y < this.qwData.length; y++) {
              const ey = this.qwData[y];
              if (ex.categoryname == ey.categoryname) {
                this.typeOn = i;
                this.category_jobs_chi = e.children;
                ex.select = true;
                e.num++;
                xzList.push(ey);
              }
            }
          }
        }
      }
      this.xzList = xzList;
    },
    // 默认赋值
    fzmrfzGet() {
      for (let i = 0; i < this.category_jobs.length; i++) {
        const e = this.category_jobs[i];
        e.num = 0;
        for (let y = 0; y < this.xzList.length; y++) {
          const ey = this.xzList[y];
          if (e.categoryname == ey.categoryname) {
            e.num++;
            e.select = true;
          }
        }
        for (let j = 0; j < e.children.length; j++) {
          const ej = e.children[j];
          for (let y = 0; y < this.xzList.length; y++) {
            const ey = this.xzList[y];
            if (ej.categoryname == ey.categoryname) {
              e.num++;
              ej.select = true;
            }
          }
          for (let x = 0; x < ej.children.length; x++) {
            const ex = ej.children[x];
            for (let y = 0; y < this.xzList.length; y++) {
              const ey = this.xzList[y];
              if (ex.categoryname == ey.categoryname) {
                e.num++;
                ex.select = true;
              }
            }
          }
        }
      }
    },
    delClick(item, ins) {
      for (let i = 0; i < this.category_jobs.length; i++) {
        const e = this.category_jobs[i];
        if (e.categoryname == item.categoryname) {
          e.num--;
          e.select = false;
        }
        for (let j = 0; j < e.children.length; j++) {
          const ej = e.children[j];
          if (ej.categoryname == item.categoryname) {
            e.num--;
            ej.select = false;
          }
          for (let x = 0; x < ej.children.length; x++) {
            const ex = ej.children[x];
            if (ex.categoryname == item.categoryname) {
              console.log(j);
              e.num--;
              ex.select = false;
            }
          }
        }
      }
      this.xzList.splice(ins, 1);
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  border-radius: 10px;
  width: 900px;
  height: 600px;
  .headBox {
    height: 70px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    .title {
      font-weight: 600;
      font-size: 18px;
      width: 220px;
    }
    .inpBox {
      width: 250px;
      height: 30px;
      border-radius: 5px;
      background-color: #f0f0f0;
      display: flex;
      .search {
        height: 30px;
        width: 40px;
        font-weight: 600;
        color: #9c9c9c;
        font-size: 18px;
      }
      .box {
        width: calc(100% - 40px);
        height: 30px;
        position: relative;
        left: -4px;
        input {
          width: 100%;
          height: 100%;
        }
      }
    }
    .youBox {
      width: 430px;
      display: flex;
      justify-content: flex-end;
      float: right;
      .close {
        font-weight: 600;
        font-size: 22px;
        cursor: pointer;
      }
    }
  }
  .kuang {
    width: 16px;
    height: 16px;
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid #c9c9c9;
    margin-left: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
  }
  .kOn {
    background-color: #147ee0;
    color: #fff;
    font-size: 14px;
    border: 1px solid #147ee0;
  }
  .ktxt {
    cursor: pointer;
  }
  .kTxtOn {
    font-weight: 600;
    color: #147ee0;
  }
  .cont {
    display: flex;
    height: calc(100% - 70px);
    .contLeft {
      width: 320px;
      border-right: 1px solid #ebebeb;
      box-sizing: border-box;
      overflow: auto;
      height: 100%;
      padding: 15px;
      .text {
        padding: 0 10px;
        height: 35px;
        border-radius: 5px;
        margin-bottom: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        .name {
          width: calc(100% - 80px);
        }
        .nameOn {
          font-weight: 600;
          color: #147ee0;
        }
        .num {
          width: 20px;
          height: 20px;
          span {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            color: #fff;
            background: #147ee0;
            font-size: 12px;
          }
        }
      }
      .on {
        background-color: #e6ecf7;
      }
      .text:hover {
        background-color: #e6ecf7;
      }
    }
    .contRig {
      width: calc(100% - 320px);
      overflow: hidden;
      position: relative;
      .nrCont {
        padding: 20px;
        height: calc(100% - 80px);
        box-sizing: border-box;
        width: 100%;
        overflow: auto;
        .nameBox {
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          .name {
            font-size: 16px;
            font-weight: 600;
          }
        }
        .nrContBox {
          overflow: hidden;
          .text {
            float: left;
            margin-bottom: 10px;
            padding: 0 13px;
            height: 30px;
            border-radius: 5px;
            background-color: #eef1f5;
            border: 1px solid #eef1f5;
            color: #000;
            margin-right: 10px;
            cursor: pointer;
            box-sizing: border-box;
          }
          .text:hover {
            box-sizing: border-box;
            border: 1px solid #147ee0;
            color: #147ee0;
            background-color: #e6ecf7;
          }
          .on {
            box-sizing: border-box;
            border: 1px solid #147ee0;
            color: #147ee0;
            background-color: #e6ecf7;
          }
        }
      }
      .diCont {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 20px;
        display: flex;
        align-items: center;
        .name {
          width: 50px;
        }
        .box {
          width: calc(100% - 130px);
          display: flex;
          .textBox {
            height: 40px;
            border-radius: 5px;
            background-color: #e6ecf7;
            padding: 0 6px 0 10px;
            margin-right: 10px;
            .close {
              font-size: 12px;
              position: relative;
              top: 2px;
              margin-left: 5px;
              cursor: pointer;
            }
          }
        }
        .btn {
          width: 80px;
          height: 38px;
          border-radius: 38px;
          background-color: #147ee0;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
